// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class BuyingPowerAvailableFund {
    constructor(name, availableFunds) {
        this.Name = name || null;
        this.AvailableFunds = availableFunds || null;
    }
}
